/* eslint max-len:0 */
import React, { Component } from 'react';
import './radio-button.css';

class RadioButton extends Component {
  constructor(props) {
    super(props);
    this.onRadioButtonClick = this.onRadioButtonClick.bind(this);
    this.dispatch = props.dispatch;
    this.state = {
      checked: props.checked || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.updateCheckedStatus(this.props.checked);
    }
  }

  onRadioButtonClick() {
    if (!this.state.checked) {
      if (this.props.callBackAction) {
        this.props.callBackAction({
          id: this.props.id,
          checked: !this.state.checked,
        });
      }
    }
  }

  updateCheckedStatus = (checkedStatus) => {
    this.setState({ checked: checkedStatus });
  };


  render() {
    const { iconType = 'round', id } = this.props;
    const iconState = {
      tick: {
        unchecked: (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            onClick={this.onRadioButtonClick}
            width="16px"
            hanging="16px"
            viewBox="0 0 16 16"
          >
            <circle
              xmlns="http://www.w3.org/2000/svg"
              id="Oval"
              cx="8"
              cy="8"
              r="6"
              strokeWidth="2px"
              fill="none"
              fillRule="evenodd"
              stroke="#CCCCCC"
            />
          </svg>
        ),
        checked: (
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            onClick={this.onRadioButtonClick}
            width="16px"
            hanging="16px"
            viewBox="0 0 16 16"
          >
            <g xmlns="http://www.w3.org/2000/svg" id="Artboard" stroke="none" strokeWidth="2px" fill="none" fillRule="evenodd">
              <circle id="Oval" cx="8" cy="8" r="6" fill="#8E009A" stroke="#8E009A" />
              <circle id="Oval-Copy" fill="#8E009A" stroke="white" cx="8" cy="8" r="5" strokeWidth="1px" />
            </g>
          </svg>
        ),
      },
    }
    ;
    return (
      <div className={`checkboxes ${iconType}`}>
        <button
          className="checkbox-wrapper"
          onClick={this.onRadioButtonClick}
          role="checkbox"
          tabIndex="0"
          aria-checked
          id={id}
        >
          {!this.state.checked ?
            iconState[iconType].unchecked
            :
            iconState[iconType].checked
          }
        </button>
      </div>
    );
  }
}

export default RadioButton;
